import { useCallback, useEffect, useRef, useState } from 'react';

import { useMobileBottomNavigation } from '../../../hooks/useMobileBottomNavigationEnabled';

export type TScrollDirection = 'up' | 'down';

export const useScrollDirection = () => {
  const isBottomNavigationEnabled = useMobileBottomNavigation();

  const [direction, setDirection] = useState<TScrollDirection | undefined>();

  const lastScrollY = useRef(0);

  const handleScroll = useCallback(() => {
    if (window.scrollY < 50) {
      lastScrollY.current = window.scrollY;

      return;
    }

    setDirection(window.scrollY > lastScrollY.current ? 'down' : 'up');

    lastScrollY.current = window.scrollY;
  }, []);

  useEffect(() => {
    if (!isBottomNavigationEnabled) {
      return () => {};
    }

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll, isBottomNavigationEnabled]);

  return direction;
};
